import React from 'react'
import classNames from 'classnames'

import { Brand } from '../Navbar'

import styles from './AuthPage.module.css'

export default function AuthPage({ children, links, wide }) {
  return (
    <div className={classNames(styles.wrapper, wide && styles.wide)}>
      <div className={styles.brandWrapper}>
        <Brand className={styles.brand} />
      </div>
      <div className={styles.children}>{children}</div>
      <div className={styles.links}>{links}</div>
    </div>
  )
}

export const Sidebar = function Sidebar({ children }) {
  return <div className={styles.sidebar}>{children}</div>
}
